/**
 * websiteSignOperationBtnsModule
 * description: website渠道下操作按钮
 * author: Qian.qianchen 2019-03-26
 */
'use strict';
angular.module('websiteSignOperationBtnsModule', []).directive('websiteSignOperationBtns', ['modalDialog', 'trsHttpService', 'sensitiveWordCheckService', 'trsspliceString', 'newMediaService', 'websiteService', '$filter', 'websiteConst', function (modalDialog, trsHttpService, sensitiveWordCheckService, trsspliceString, newMediaService, websiteService, $filter, websiteConst) {
    return {
        restrict: 'E',
        replace: false,
        templateUrl: './editingCenter/iWo/fusionSign/directive/websiteSignOperationBtns/websiteSignOperationBtns_tpl.html',
        scope: {
            selectedArr: '=',
            callback: '&'
        },
        link: function ($scope, iElement, attrs) {
            initStatus();

            /**
                 * [dealOperParams description]处理参数
                 * @return {[type]} [description]
                 */
            function initStatus() {
                $scope.status = {
                    signedSuccess: false
                };
                $scope.data = {};
                $scope.newOperationParams = {
                    serviceid: 'mlf_fusion',
                    methodname: 'doActionOnMediaTypeAndDocIdsSync',
                    oprType: 'daishen',
                    actionKey: '',
                    // mediaTypeDocIds: [],
                    // OprTime: $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    // OprTimeStart: '',
                    // OprTimeEnd: '',
                };
            }

            /**
                 * [dealOperParams description]处理参数
                 * @return {[type]} [description]
                 */
            function dealOperParams() {
                $scope.newOperationParams.mediaTypeDocIds = [];
                $scope.selectedArr.forEach((item) => {
                    $scope.newOperationParams.mediaTypeDocIds.push({
                        MEDIATYPE: item.MEDIATYPE,
                        DOCID: item.METADATAID
                    });
                });
                $scope.newOperationParams.mediaTypeDocIds = JSON.stringify($scope.newOperationParams.mediaTypeDocIds);
            }

            /**
             * [directSigned description] 签发
             */
            $scope.directSigned = function (item) {
                var queryTitleContent = true;
                var queryShenKanQianFa = trsspliceString.spliceString($scope.selectedArr, 'CLIENTEXAMINE', ',');
                if (queryShenKanQianFa.indexOf('0') == -1) {
                    queryTitleContent = false;
                }
                sensitiveWordCheckService.SensitiveWordsAndCareful($scope.selectedArr, '', 2, queryTitleContent).then(function () {
                    $scope.status.signedSuccess = true;
                    signed(item);
                }, function () {
                    modalDialog.confirmModal('签发', '确认直接签发?', function () {
                        signed(item);
                    });
                });
            };

            /**
             * [signed description] 签发方法
             */
            function signed(item) {
                dealOperParams();
                $scope.newOperationParams.actionKey = 'qianfa';
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.newOperationParams, 'get').then(function (data) {
                    modalDialog.alertType('直接签发成功', '', 'success', false, function () {
                        $scope.callback();
                    });
                }, function () {
                    $scope.callback();
                });
            }

            /**
             * [multitermTiimeSigned description]
             *
             * @return  {[type]}  [return description]
             */
            $scope.multitermTiimeSigned = function () {
                sensitiveWordCheckService.SensitiveWordsAndCarefulTiming($scope.selectedArr).then(function () { }, function () {
                    timeSigned();
                });
            };

            /**
             * [timeSigned description] 定时签发方法
             */
            function timeSigned() {
                $scope.requestData = $scope.callback;
                $scope.data.selectedArray = $scope.selectedArr;
                $scope.loadingPromise = newMediaService.timeSign($scope, websiteConst.daishenTimeSign, signCallBack);
                // dealOperParams();
                // $scope.newOperationParams.selectedArray = $scope.selectedArr;
                // $scope.newOperationParams.actionKey = 'dingshiqianfa';
                // $scope.loadingPromise = editingCenterService.draftTimeSinged($scope.newOperationParams).then(function (data) {
                //     modalDialog.alertType('定时签发成功', '', 'success', false, function () {
                //         $scope.callback();
                //     });
                // }, function (result) {
                //     $scope.callback();
                // });
                // var params = {
                //     selectedArray: $scope.selectedArr,
                //     isNewDraft: false,
                //     methodname: 'webDaiShenTimingPublish'
                // };
                // $scope.loadingPromise = editingCenterService.draftTimeSinged(params).then(function (data) {
                //     modalDialog.alertType('定时签发成功', '', 'success', false, function () {
                //         $scope.callback();
                //     });
                // }, function (data) {
                //     data.REPORTS = data.reports;
                //     websiteService.afterSigning(data, 'webDaiShenTimingPublish', true).then(function () {
                //         $scope.callback();
                //     }, function () {
                //         $scope.callback();
                //     });
                // });
            }

            /**
             * [signCallBack description] 签发回调, 主要是强制签发时组装参数
             * @param   {[type]}  params  [params description]
             * @param   {[type]}  array   [array description]
             * @return  {[type]}          [return description]
             */
            function signCallBack(params, array) {
                var ChnlDocIds = [];
                var ObjectIds = [];
                var MetaDataIds = [];
                for (var i = 0; i < array.length; i++) {
                    ChnlDocIds.push(array[i].DOC.CHNLDOCID);
                    ObjectIds.push(array[i].DOC.CHNLDOCID);
                    MetaDataIds.push(array[i].DOC.METADATAID);
                }
                params.ChnlDocIds = ChnlDocIds.join(',');
                params.ObjectIds = ObjectIds.join(',');
                params.MetaDataIds = MetaDataIds.join(',');
            }

            /**
             * [lookSigned 审看签发]
             * @return {[type]} [description]
             */
            $scope.lookSigned = function () {
                var queryTitleContent = true;
                var queryShenKanQianFa = trsspliceString.spliceString($scope.selectedArr, 'CLIENTEXAMINE', ',');
                var ChnlDocIds = trsspliceString.spliceString($scope.selectedArr, 'CHNLDOCID', ',');
                if (queryShenKanQianFa.indexOf('1') == -1) {
                    modalDialog.alertType('未同意签发的稿件不允许审看签发', '', 'error', false, function () { });
                    return;
                }
                // 如果稿件全部带审看权限,直接签发,不填写提示内容
                if (queryShenKanQianFa.indexOf('0') == -1) {
                    queryTitleContent = false;
                }
                sensitiveWordCheckService.SensitiveWordsAndCareful($scope.selectedArr, '', 2, queryTitleContent).then(function () {
                    $scope.status.signedSuccess = true;
                    lookatSigned(ChnlDocIds);
                }, function () {
                    modalDialog.confirmModal('签发', '确认是否签发', function () {
                        lookatSigned(ChnlDocIds);
                    });
                });
            };

            /**
             * [lookatSigned 审看签发]
             * @return {[type]} [description]
             */
            function lookatSigned(item) {
                var params = {
                    'serviceid': 'mlf_websiteoper',
                    'methodname': 'webDaiShenKanShenPublish',
                    'ChnlDocIds': item
                };
                promptRequest(params, '审看签发成功');
            }

            /**
             * [promptRequest description]具体操作数据请求成功后刷新列表
             * @param  {[obj]} params [description]请求参数
             * @param  {[string]} info   [description]提示语
             * @return {[type]}        [description]
             */
            function promptRequest(params, info) {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', true).then(function (data) {
                    if ($scope.status.signedSuccess) {
                        modalDialog.multiReportsAlert(data, function () {
                            $scope.callback();
                        });
                    } else {
                        modalDialog.alertType(info, '', 'success', false, function () {
                            $scope.callback();
                        });
                    }
                    $scope.status.signedSuccess = false;
                }, function (data) {
                    websiteService.afterSigning(data, 'webDaiShenPublish').then(function () {
                        $scope.callback();
                        $scope.status.signedSuccess = false;
                    }, function () {
                        $scope.callback();
                        $scope.status.signedSuccess = false;
                    });
                });
            }

            /**
             * [rejectionDraft description] 撤稿
             */
            $scope.rejectionDraft = function () {
                modalDialog.inputModel('撤稿', '撤稿原因（选填）', function (content) {
                    rejection(content);
                });
            };

            /**
             * [rejection description] 退稿方法
             */
            function rejection(Opinion) {
                dealOperParams();
                $scope.newOperationParams.actionKey = 'tuigao';
                // var params = {
                //     'serviceid': 'mlf_websiteoper',
                //     'methodname': 'rejectionMetaDatas',
                //     'ChannelId': $scope.selectedArr[0].CHANNELID,
                //     'Opinion': Opinion,
                //     'ChnlDocIds': trsspliceString.spliceString($scope.selectedArr, 'CHNLDOCID', ','),
                //     'metaDataIds': trsspliceString.spliceString($scope.selectedArr, 'METADATAID', ','),
                // };
                // promptRequest($scope.newOperationParams, '撤稿成功');
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.newOperationParams, 'get').then(function () {
                    modalDialog.alertType('撤稿成功', '', 'success', false, function () {
                        $scope.callback();
                    });
                }, function () {
                    $scope.callback();
                });
            }
        }
    };
}]);
